const login = {
  defaults: {
    rememberMe: true,
  },
}

export default login
